// extracted by mini-css-extract-plugin
export default {"name":"UserNameCardChip_name__P3OFx","cardContainer":"UserNameCardChip_cardContainer__fgxhM"};